import FormattedMessage from 'I18n/components/FormattedMessage';
import UITable from 'UIComponents/table/UITable';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { createActionCardCounters } from 'automation-ui-action-features/records/recordsUtils';
import EnrollmentConversionPanelCompletedRow from 'automation-ui-canvas/containers/enrollment-conversion/panel/table/EnrollmentConversionPanelCompletedRow';
import { getAllEndMarkersData } from 'automation-ui-canvas/utils/endMarkerFlowUtils';
import { translateToGraph } from 'automation-ui-canvas/utils/platformWorkflowTranslators';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentConversionPanelCompletedContent = ({
  flow,
  isReportingEnabled,
  enrollmentConversionData
}) => {
  const flowAsGraph = translateToGraph(flow, false);
  const actionCardCounters = createActionCardCounters(flow.getActions(), flow.firstActionId);
  const endMarkerNodes = getAllEndMarkersData({
    flow,
    directedGraph: flowAsGraph
  });
  const sortedEndMarkerNodesArray = Array.from(endMarkerNodes).sort(([, aValue], [, bValue]) => {
    return Number(actionCardCounters[aValue.fromNode]) - Number(actionCardCounters[bValue.fromNode]);
  });
  return /*#__PURE__*/_jsxs(UITable, {
    hover: false,
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx("col", {
        style: {
          width: '75%'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '25%'
        }
      })]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.panel.tooltips.endHeader"
        }),
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentConversion.panel.endsTable.ends"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentConversion.panel.endsTable.conversion"
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: sortedEndMarkerNodesArray.map(([key, value]) => /*#__PURE__*/_jsx(EnrollmentConversionPanelCompletedRow, {
        enrollmentConversionData: enrollmentConversionData,
        nodeId: value.fromNode,
        isReportingEnabled: isReportingEnabled,
        actionCardCounters: actionCardCounters
      }, key))
    })]
  });
};
export default EnrollmentConversionPanelCompletedContent;